var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87061 5.41858L5.65186 16.4034C5.68896 17.0381 6.21436 17.5019 6.90186 17.5019H14.0894C14.7796 17.5019 15.2952 17.0381 15.3394 16.4034L16.1206 5.41858",
    stroke: "#757575",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62109 5.41895H17.3711",
    stroke: "#757575",
    strokeWidth: 1.00189,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99561 5.41723V3.85451C7.99525 3.73127 8.01925 3.60919 8.06625 3.49526C8.11324 3.38134 8.18229 3.27783 8.26943 3.1907C8.35657 3.10356 8.46008 3.0345 8.574 2.98751C8.68792 2.94052 8.81001 2.91651 8.93324 2.91687H12.0587C12.1819 2.91651 12.304 2.94052 12.4179 2.98751C12.5319 3.0345 12.6354 3.10356 12.7225 3.1907C12.8096 3.27783 12.8787 3.38134 12.9257 3.49526C12.9727 3.60919 12.9967 3.73127 12.9963 3.85451V5.41723",
    stroke: "#757575",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4961 7.91663V15.8333",
    stroke: "#757575",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68311 7.91663L7.99561 15.8333",
    stroke: "#757575",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3081 7.91663L12.9956 15.8333",
    stroke: "#757575",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic-delete.3539c96ecba8029b517836079ec30b59.svg";
export { ForwardRef as ReactComponent };